import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  Grid,
  FormGroup,
  FormLabel,
  TextField,
  CardContent,
  Button,
  LinearProgress,
} from "@material-ui/core";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";

const useStyles = makeStyles(componentStyles);

export default function SalesInformation({
  cpf,
  idVendedor,
  idLoja,
  isMobile,
}) {
  const classes = useStyles();
  const snackbar = useSnackbar();

  const [date, setDate] = useState("");
  const [info, setInfo] = useState("");
  const [submit, setSubmit] = useState(false);

  const today = new Date();
  const formatDate = new Date(today.setDate(new Date().getDate()))
    .toISOString()
    .slice(0, 10);

  const handleCreateInfoSeller = async () => {
    setSubmit(true);

    try {
      const res = await Api.post(
        "create-info-sale",
        "action",
        {
          Cpf: cpf?.replace(/\D/g, ""),
          IdPessoaLoja: idLoja?.toString(),
          Data: date,
          InfoVenda: info,
          IdLojaVendedor: idVendedor,
        },
        true
      );
      if (res?.Success) {
        snackbar.showMessage(`Informação de venda criada com sucesso!`, {
          severity: "success",
        });
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
      });    } finally {
      setDate("");
      setInfo("");
      setSubmit(false);
    }
  };

  return (
    <Grid
      container
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "baseline",
      }}
    >
      <Grid item xs={12}>
        <Card classes={{ root: classes.cardRoot }} style={{ display: "flex" }}>
          <CardContent>
            <Grid container style={{ display: "flex", alignItems: "center" }}>
              <Grid item xs={isMobile ? 12 : 4}>
                <FormGroup>
                  <FormLabel>Data</FormLabel>
                  <TextField
                    fullWidth
                    name="date"
                    type="date"
                    value={date}
                    variant="outlined"
                    disabled={submit}
                    onChange={(e) => setDate(e.target.value)}
                    inputProps={{
                      max: formatDate,
                      onKeyDown: (event) => {
                        event.preventDefault();
                      },
                    }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={isMobile ? 12 : 4}>
                <FormGroup>
                  <FormLabel>Informação da Venda</FormLabel>
                  <TextField
                    fullWidth
                    multiline
                    name="info"
                    type="text"
                    value={info}
                    variant="outlined"
                    disabled={submit}
                    onChange={(e) => setInfo(e.target.value)}
                    onInput={(e) => {
                      e.target.value = e.target.value.toString().slice(0, 500);
                    }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={isMobile ? 12 : 4}>
                <Button
                  variant="contained"
                  onClick={handleCreateInfoSeller}
                  disabled={submit || info === "" || date === ""}
                >
                  {submit ? "Registrando..." : "Registrar"}
                </Button>
              </Grid>
            </Grid>
            {submit && (
              <div
                className={classes.root}
                style={{ marginTop: "1.5rem", marginBottom: "-1rem" }}
              >
                <span>Registrando informação de venda...</span>
                <LinearProgress />
              </div>
            )}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
